import { render } from "./PriceChart.vue?vue&type=template&id=449bd613"
import script from "./PriceChart.vue?vue&type=script&lang=js"
export * from "./PriceChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__